module.exports = __webpack_public_path__ + "img/lanmu-01.6ad9f3a3.jpg";